import { render, staticRenderFns } from "./PublicJobBoardConfig.vue?vue&type=template&id=49e37812&scoped=true"
import script from "./PublicJobBoardConfig.vue?vue&type=script&lang=js"
export * from "./PublicJobBoardConfig.vue?vue&type=script&lang=js"
import style0 from "./PublicJobBoardConfig.vue?vue&type=style&index=0&id=49e37812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e37812",
  null
  
)

export default component.exports